module.exports = __webpack_public_path__ + "img/service-head-bg-4.a7945c30.jpg";